import { p } from "motion/react-client";
import Icon1 from "./Icons/Icon1";
import Icon2 from "./Icons/Icon2";
import Icon3 from "./Icons/Icon3";
import Icon4 from "./Icons/Icon4";
import Icon5 from "./Icons/Icon5";
import Icon6 from "./Icons/Icon6";
import Icon7 from "./Icons/Icon7";

export default function CardKeyDemoBig({item, className= '', ...props}) {
    const hasLinks = item.links && item.links.length > 0;
    
    return (
        <div className={`flex flex-row rounded-50u border-2u border-[#e2e2e2] bg-[#0E2242] w-full ${className} relative`} {...props}>
            <div className={`
                absolute
                w-full h-125u
                text-34u leading-none
                bg-${item.color}
                ${item.color === 'white' ? 'text-navy' : ''}
                bottom-0 left-0
                flex items-center justify-center
                rounded-b-50u
                z-10
                `}
                >
                    To start the conversation, find an expert with a lanyard that says:&nbsp;<b>{item.category}</b>
                </div>

            <div className={`
            ${!!item.img ? 'w-1277u' : 'w-1570u'}
            flex-shrink-0
            pl-165u pr-103u pt-130u pb-[9.75rem] leading-none
            flex flex-col
            relative
            ${!!item.products && 'border-r-2u border-[#A9AAB5]'}
            `}>
                <div className="font-medium text-42u text-silver leading-none mb-34u">
                    {item.category}
                </div>

                <div className="font-light text-72u leading-82u mb-35u">
                    {item.title}
                </div>
                {!!item.subtitle && (
                    <div className="font-bold text-44u leading-82u mb-35u">
                    {item.subtitle}
                </div>
                )}
                <div className="font-light text-38u leading-58u mb-60u text-[#C7C8D3]">
                    {item.description}
                </div>

                {!!item.qr && (
                <>
                    <div className="flex flex-row items-center">
                        <img
                            src={`${process.env.PUBLIC_URL}/qr/${item.qr}`}
                            alt={item.qr_title}
                            className="w-160u h-160u object-cover rounded-[1.25rem] mr-[4.125rem]"
                        />
                        <div className="text-42u">{item.qr_title}</div>
                    </div>
                </>
                )}

                <div className={`
                    absolute
                    w-184u h-184u
                    rounded-full
                    border-26u
                    border-${item.border_color || item.color}
                    border-b-transparent
                    border-l-transparent
                    transform
                    -left-2u top-85u
                    -translate-x-1/2
                    rotate-[-135deg]
                    opacity-30
                    z-0
                    `}>
                </div>

                <div className={`absolute
                flex
                w-135u h-135u rounded-full
                font-normal text-[6.375rem] leading-none
                bg-${item.color || '03BCE9'}
                ${item.color === 'white' ? 'text-navy' : ''}
                justify-center items-center
                left-0 top-109u
                -translate-x-1/2`}
                >
                    {item.id === 1 && (
                        <Icon1 className="w-70u h-auto" />
                        )}
                        {item.id === 2 && (
                        <Icon2 className="w-80u h-auto" />
                        )}
                        {item.id === 3 && (
                        <Icon3 className="w-70u h-auto" />
                        )}
                        {item.id === 4 && (
                        <Icon4 className="w-80u h-auto" />
                        )}
                        {item.id === 5 && (
                        <Icon5 className="w-65u h-auto" />
                        )}
                        {item.id === 6 && (
                        <Icon6 className="w-70u h-auto" style={{filter: 'brightness(0) saturate(100%) invert(8%) sepia(37%) saturate(1299%) hue-rotate(194deg) brightness(93%) contrast(95%)'}} />
                        )}
                        {item.id === 7 && (
                        <Icon7 className="w-70u h-auto" />
                        )}
                </div>

            </div>

            <div className={`
                flex flex-col
                flex-1 min-w-0
                mb-130u
                ${!!item.products && 'pt-134u pl-143u'}
                ${!!item.img && 'pt-102u'}
                `}>
                {!!item.products && (
                    <>
                        <div className="
                        mb-[2.875rem]
                        text-42u leading-none text-silver"
                        >Related products</div>
                        {item.products.map((product, i) => (
                            <div key={i} className="mb-33u font-normal text-48u leading-58u" dangerouslySetInnerHTML={{ __html: product }}></div>
                        ))}
                    </>
                )}

                {!!item.img && (
                <>
                    <div className="flex flex-row items-center">
                        <img
                            src={`${process.env.PUBLIC_URL}/${item.img}`}
                            className="w-1156u h-856u
                            rounded-32u"
                        />
                        <div className="text-42u">{item.qr_title}</div>
                    </div>
                </>
                )}
            </div>
            
        </div>
    );
};